import React, { ReactElement } from 'react';
import { Location, useLocation } from 'react-router-dom';

import { ACTIVE } from '../../utils/constants';

import HeaderContainer from '../../containers/header/Header.container';

import ProgrammeMenu from '../../components/common/programme/programme-menu/ProgrammeMenu';
import ProgrammeNavbar from '../../components/common/programme/programme-navbar/ProgrammeNavbar';

import backgroundTwo from '../../resources/images/background-two.jpg';
import backgroundThree from '../../resources/images/background-three.jpg';

import './programme-layout.scss';

interface Props extends React.PropsWithChildren<unknown> {
  onNavigate?: (value: string) => void;
  hideNav?: boolean;
}

const ProgrammeLayout = ({ children, onNavigate, hideNav = false }: Props): ReactElement => {
  const location: Location = useLocation();

  let backgroundImage: string;

  if (location.pathname.toLowerCase().includes(ACTIVE) || hideNav) {
    backgroundImage = backgroundTwo;
  } else {
    backgroundImage = backgroundThree;
  }

  return (
    <div className="programme-layout" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <HeaderContainer />
      <div className="programme-layout__content">
        <ProgrammeMenu onNavigate={onNavigate} />
        <div className="programme-layout__current-programme">
          {!hideNav && <ProgrammeNavbar onNavigate={onNavigate} />}
          <div className="programme-layout__current-programme__content">{children}</div>
          <div className="programme-layout__footer" />
        </div>
      </div>
    </div>
  );
};

export default ProgrammeLayout;
